module.exports = __webpack_public_path__ + "img/547e9b63a51ef3135b4833505e68915c.png";